import React, { useEffect, useRef, useState, useContext } from 'react';
import { AuthContext } from '../pages/contexts/AuthContext';
import { toast } from 'react-toastify';
import NoteCard from '../pages/NoteCard';
import Header from '../components/Header';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const Notes = () => {
  const VITE_BASE_URL = process.env.REACT_APP_API_URL;
  const modalRef = useRef(null);
  const { user } = useContext(AuthContext);
  const [title, setTitle] = useState('');
  const [desc, setDescription] = useState('');
  const [notes, setNotes] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState({ page: true, action: false });
  const bsModalRef = useRef(null);

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        setLoading(prev => ({ ...prev, page: true }));
        const response = await fetch(`${VITE_BASE_URL}/api/notes`);
        const data = await response.json();
        setNotes(data);
      } catch (error) {
        console.error('Error fetching notes:', error);
        toast.error('Failed to load notes');
      } finally {
        setLoading(prev => ({ ...prev, page: false }));
      }
    };
    fetchNotes();
  }, []);

  const handleAddNote = () => {
    const modalElement = modalRef.current;
    if (modalElement) {
      const modal = new window.bootstrap.Modal(modalElement);
      bsModalRef.current = modal; // ✅ store instance
      modal.show();
    }
  };

  const saveNote = async () => {
    if (!title || !desc) {
      toast.warn("Both fields are required!");
      return;
    } setLoading(prev => ({ ...prev, action: true }));
    try {
      const response = await fetch(`${VITE_BASE_URL}/api/notes/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title, desc, uname: user?.uname }),
      });

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || 'Failed to save note');
      }

      setNotes(prevNotes => [result.note, ...prevNotes]);
      setTitle('');
      setDescription('');
      if (bsModalRef.current) {
        bsModalRef.current.hide(); // ✅ close modal correctly
      }
      toast.success('Note saved successfully!');
    } catch (error) {
      console.error('Save error:', error.message);
      toast.error("Failed to save note.");
    } finally {
      setLoading(prev => ({ ...prev, action: false }));
    }
  };

  const handleRemoveNote = (id) => {
    setLoading(true);
    setNotes(prev => prev.filter(n => n._id !== id));
    setLoading(false);
  };

  const getFilteredNotes = () => {
    if (filter === 'fav') return notes.filter(note => note.isFav);
    if (filter.startsWith('tag:')) {
      const tag = filter.split(':')[1];
      return notes.filter(note => note.tag === tag);
    }
    return notes;
  };

  const handleFavToggle = (id, newIsFav) => {
    setNotes(prevNotes =>
      prevNotes.map(note =>
        note._id === id ? { ...note, isFav: newIsFav } : note
      )
    );
  };

  const handleTagChange = (id, newTag) => {
    setNotes(prevNotes =>
      prevNotes.map(note =>
        note._id === id ? { ...note, tag: newTag } : note
      )
    );
  };

  return (

    <div>
      <div className="main-container sidebar-closed sbar-open" id="container">
        <Header/>
        <div className="overlay" />
        <div className="cs-overlay" />
        <div className="search-overlay" />
        <Nav/>
        <div id="content" className="main-content">
          <div className="layout-px-spacing">
            <div className="row app-notes layout-top-spacing" id="cancel-row">
              <div className="col-lg-12">
                <div className="app-hamburger-container">
                  <div className="hamburger">
                    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu chat-menu d-xl-none"><line x1={3} y1={12} x2={21} y2={12} /><line x1={3} y1={6} x2={21} y2={6} /><line x1={3} y1={18} x2={21} y2={18} /></svg>
                  </div>
                </div>
                <div className="app-container">
                  <div className="app-note-container">
                    <div className="app-note-overlay" />
                    <div className="tab-title">
                      <div className="row">
                        <div className="col-md-12 text-center">
                          <a className="btn btn-dark" href="#"
                            onClick={(e) => { e.preventDefault(); handleAddNote(); }}>
                            Add
                          </a>
                        </div>
                        <div className="col-md-12 mt-5">
                          <ul className="nav nav-pills d-block" role="tablist">
                            <li className="nav-item">
                              <a className="nav-link list-actions" onClick={() => setFilter('all')}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-edit">
                                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                </svg> All Notes
                              </a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link list-actions" onClick={() => setFilter('fav')}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-star">
                                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg> Favourites
                              </a>
                            </li>
                          </ul>
                          <hr />
                          <p className="group-section">
                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-tag">
                              <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                              <line x1={7} y1={7} x2={7} y2={7} />
                            </svg> Tags
                          </p>
                          <ul className="nav nav-pills d-block group-list">
                            <li className="nav-item">
                              <a className="nav-link list-actions g-dot-primary" onClick={() => setFilter('tag:personal')}>Personal</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link list-actions g-dot-warning" onClick={() => setFilter('tag:work')}>Work</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link list-actions g-dot-success" onClick={() => setFilter('tag:social')}>Social</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link list-actions g-dot-danger" onClick={() => setFilter('tag:important')}>Important</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div id="ct" className="note-container note-grid">
                      {getFilteredNotes().length === 0 ? (
                        <p>No notes found.</p>
                      ) : (
                        getFilteredNotes().map(note => (
                          <NoteCard key={note._id} note={note} onDelete={handleRemoveNote} onToggleFav={handleFavToggle} onTagChange={handleTagChange} setLoading={(loader) => setLoading(prev => ({ ...prev, action: loader }))} />
                        ))
                      )}
                    </div>
                  </div>
                </div>

                {/* Modal */}
                <div className="modal fade" id="notesMailModal" tabIndex={-1} role="dialog" ref={modalRef}>
                  <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                      <div className="modal-body">
                        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={30} className="feather feather-x close" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" onClick={() => {
                          setTitle('');
                          setDescription('');
                          bsModalRef.current?.hide();
                        }}>
                          <line x1={18} y1={6} x2={6} y2={18} />
                          <line x1={6} y1={6} x2={18} y2={18} />
                        </svg>
                        <div className="notes-box">
                          <div className="notes-content">
                            <form onSubmit={(e) => e.preventDefault()}>
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="d-flex note-title">
                                    <input type="text" className="form-control" placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="d-flex note-description">
                                    <textarea className="form-control" placeholder="Description" rows={3} value={desc} onChange={(e) => setDescription(e.target.value)} />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button className="btn" onClick={() => {
                          setTitle('');
                          setDescription('');
                          bsModalRef.current?.hide();
                        }}>Discard</button>
                        <button className="btn btn-primary" onClick={saveNote}>Add</button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Modal */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default Notes;
